/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { Category } from "../interfaces/intefaces";
import { routes } from "../router/Routes";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "./Icon";
import {
    AllGamesIcon,
    FavoritesIcon,
    LobbyIcon,
    MoreGamesIcon,
    NewGamesIcon,
    OtherGamesIcon,
    TopPicksIcon,
} from "./Icons";
import { useTranslation } from "../hooks/hooks";
import { useAtom } from "jotai";
import { activeProvidersAtom, userIsLoggedInAtom } from "../state/games";
import { getCategoryIcon, scrollToTop } from "../helpers/helpers";
declare const initCallback: () => void;

interface IProps {
    categories: Category[];
    activeCategory: number;
    updateCategory: (category_id: number) => void;
    setCategoryType: (categoryType: number) => void;
}

const Categories: React.FC<IProps> = ({
    categories,
    activeCategory,
    updateCategory,
    setCategoryType,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { _e } = useTranslation();

    const [, setActiveProviders] = useAtom(activeProvidersAtom);
    const hotGames = location.pathname === routes.pages.hot ? 1 : 0;
    const newGames = location.pathname === routes.pages.new ? 1 : 0;
    const lobby = location.pathname === routes.root ? 1 : 0;
    const favorites = location.pathname === routes.pages.favorites ? 1 : 0;
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const allGames = location.pathname === routes.pages.games ? 1 : 0;

    useEffect(() => {
        initCallback();
    }, []);

    const handleLinkClick = (route: string, category: number, categoryType?: null | number) => {
        if (location.pathname === routes.root || location.pathname.startsWith("/games")) {
            scrollToTop();
            setActiveProviders([]);
            categoryType && setCategoryType(categoryType);
            updateCategory(category);
            navigate(route);
        } else {
            window.location.href = "/#" + route;
        }
    };

    return (
        <>
            <div className="categories">
                <div
                    title={_e("Lobby")}
                    className={lobby ? "category active" : "category"}
                    onClick={() => handleLinkClick(routes.root, 0)}
                >
                    <div>
                        <Icon icon={LobbyIcon} />
                        <span className="title">{_e("Lobby")}</span>
                    </div>
                </div>
                <div
                    title={_e("Favourites")}
                    className={favorites ? "category favorites active" : "category favorites"}
                    onClick={() => handleLinkClick(routes.pages.favorites, 0)}
                >
                    <div className={!userIsLoggedIn ? "inactive" : ""}>
                        <Icon icon={FavoritesIcon} />
                        <span className="title">{_e("Favourites")}</span>
                    </div>
                </div>
                <div
                    className={hotGames ? "category active" : "category"}
                    data-slug="hot"
                    onClick={() => handleLinkClick(routes.pages.hot, 0)}
                >
                    <div title={_e("Recommended")}>
                        <Icon icon={TopPicksIcon} />
                        <span className="title">{_e("Recommended")}</span>
                    </div>
                </div>
                <div
                    title={_e("New Games")}
                    data-slug="new"
                    className={newGames ? "category  active" : "category"}
                    onClick={() => handleLinkClick(routes.pages.new, 0)}
                >
                    <div>
                        <Icon icon={NewGamesIcon} />
                        <span className="title">{_e("New games")}</span>
                    </div>
                </div>

                {categories.map(category => {
                    return (
                        <div
                            className={
                                activeCategory === category.id
                                    ? `category ${category.slug} active`
                                    : `category ${category.slug}`
                            }
                            key={category.id}
                            data-slug={category.slug}
                        >
                            <div
                                title={category.name}
                                onClick={() =>
                                    handleLinkClick(
                                        `${routes.pages.games}/${category.slug}`,
                                        category.id,
                                        category.type,
                                    )
                                }
                            >
                                <Icon icon={getCategoryIcon(category.slug)} />
                                <span className="title">{category.name}</span>
                            </div>
                        </div>
                    );
                })}
                <div
                    className={allGames ? "category active" : "category"}
                    onClick={() => {
                        handleLinkClick(`${routes.pages.games}`, 0, activeCategory);
                    }}
                >
                    <div title={_e("More Games")}>
                        <Icon icon={MoreGamesIcon} />
                        <span className="title">{_e("More Games")}</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Categories;
